/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Game from '../Game/Game';
import InjectableComponent from './Component/ComponentReference/InjectableComponent';
import ComponentBase from './ComponentBase';

const {ccclass, property} = cc._decorator;

@ccclass
export class InputManager extends ComponentBase
{
    private _gameRef: InjectableComponent<Game> = new InjectableComponent();

    protected setContexts(): void
    {
        this._gameRef.SetContext(Game);
    }

    protected onLoad(): void
    {
        super.onLoad();

        cc.systemEvent.on(cc.SystemEvent.EventType.KEY_DOWN, this.onKeyDown, this);
        cc.systemEvent.on(cc.SystemEvent.EventType.KEY_UP, this.onKeyUp, this);
    }

    public onKeyDown(event: any): void
    {
        switch (event.keyCode)
        {
            case cc.KEY.num6:
            {
                this._gameRef.Value.OnSpinButtonClicked(event);
                break;
            }
            case cc.KEY.f8:
            {
                this.setDtMod(100 * 1000);
                break;
            }
            case cc.KEY.f9:
            {
                this.setDtMod(Math.max(0, this._dtMod * .9));
                break;
            }
            case cc.KEY.f10:
            {
                this.setDtMod(Math.min(100, this._dtMod + 0.1));
                break;
            }
            case cc.KEY.f11:
            {
                this.setDtMod(1.0);
                break;
            }
            case cc.KEY.f12:
            {
                this.setDtMod(0.0);
                break;
            }

        }
    }

    private setDtMod(value: number): void
    {
        this._gameRef.Value.DtModObservable.Value = value;
    }

    private get _dtMod(): number { return this._gameRef.Value.DtModObservable.Value; }

    public onKeyUp(event: any): void
    {
        return;
    }
}
